/** @graphql cc **/

import gql from 'graphql-tag';

export const UserQuery = gql`
	query UserQuery($id: ID!) {
		user: confluence_atlassianUser(id: $id) {
			id
			displayName
			photos {
				value
			}
		}
	}
`;
